import React from "react";
import { useLocation } from "react-router-dom";
import { serverApi } from "../../../confing/confing";
import toast from "react-hot-toast";
import axios from "axios";
import { useEffect, useState } from "react";

const UserTransaction = () => {
  const { state } = useLocation();
  const [list, setList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (state.userToken) {
          let token = localStorage.getItem("token");
          const { data } = await axios.get(
            `${serverApi}user/transactions/${state.userToken}`,
            {
              headers: { authorization: `Bearer ${token}` },
            }
          );
          console.log(data);
          setList(data.result);
        }
        // setInfo(data.result);
      } catch (err) {
        console.log(err);
        toast.error("خطایی رخ داده است مجددا تلاش کنید");
      }
    };
    fetchData();
  }, []);
  const activeExpert = async () => {
    try {
      let token = localStorage.getItem("token");
      if (state.userToken) {
        const { data } = await axios.put(
          `${serverApi}user/${state.userToken}/active`,
          {},
          {
            headers: { authorization: `Bearer ${token}` },
          }
        );
        console.log(data);
        toast.success("عملیات با موفقیت انجام شد");
      } else {
        toast.error("توکن کاربر موجود نیست");
      }
    } catch (err) {
      console.log(err);
      toast.error("خطایی رخ داده است مجددا تلاش کنید");
    }
  };
  const deactiveExpert = async () => {
    try {
      let token = localStorage.getItem("token");
      if (state.userToken) {
        const { data } = await axios.put(
          `${serverApi}user/${state.userToken}/inActive`,
          {},
          {
            headers: { authorization: `Bearer ${token}` },
          }
        );
        console.log(data);
        toast.success("عملیات با موفقیت انجام شد");
      } else {
        toast.error("توکن کاربر موجود نیست");
      }
    } catch (err) {
      console.log(err);
      toast.error("خطایی رخ داده است مجددا تلاش کنید");
    }
  };
  return (
    <div className="p-3 px-lg-5 py-lg-3">
      {state.userToken ? (
        <div
          className="table-responsive p-0"
          style={{
            border: "1px solid #fff",
            borderRadius: "20px",
            backgroundColor: "rgba(255, 255, 255, 0.50)",
          }}
        >
          <table
            className="table table-bordered text-center mb-0"
            style={{ borderRadius: "20px", borderColor: "#fff" }}
          >
            <thead>
              <tr style={{ color: "#000" }}>
                <th scope="col">ردیف</th>
                <th scope="col">نام و نام خانوادگی کابر</th>
                <th scope="col">تاریخ واریز</th>
                <th scope="col">مبلغ واریز</th>
                <th scope="col">موضوع واریز</th>
                <th scope="col">کد پیگیری</th>
                <th scope="col">شماره صورت کارشناسی</th>
                <th scope="col">وضعیت پرداخت</th>
                <th scope="col">آیدی فاکتور</th>
              </tr>
            </thead>
            <tbody>
              {list.map((i, index) => (
                <tr key={index} style={{ color: "#000" }}>
                  <td>{index+1}</td>
                  <td>{i.Ex_Owner?.name}</td>
                  <td>
                    {" "}
                    {i.Ex_Factor?.updatedAt &&
                      new Intl.DateTimeFormat("fa-IR").format(
                        new Date(i.Ex_Factor?.updatedAt)
                      )}
                  </td>
                  <td>{i.Ex_Factor?.amount?.toLocaleString()}</td>
                  <td>{i.Ex_Factor?.description}</td>
                  <td>{i.Ex_Factor?.RefId}</td>
                  <td>{i.requestToken}</td>
                  <td>{i.isPay ? "پرداخت شده " : "پرداخت نشده"}</td>
                  <td>{i.ExFactorId}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>این کاربر هیچ تراکنشی ندارد</p>
      )}
      <div className="text-start mt-3">
        {state.isActive ? (
          <button
            className="btn ms-3"
            style={{
              width: "200px",
              backgroundColor: "#EF971C",
              borderRadius: "20px",
            }}
            onClick={() => {
              deactiveExpert();
            }}
            type="button"
          >
            غیر فعال کردن کاربر
          </button>
        ) : (
          <button
            className="btn ms-3"
            style={{
              width: "200px",
              backgroundColor: "#EF971C",
              borderRadius: "20px",
            }}
            onClick={() => {
              activeExpert();
            }}
            type="button"
          >
            فعال کردن کاربر
          </button>
        )}
      </div>
    </div>
  );
};

export default UserTransaction;
